// src/pages/sales-order/tabs/AddressTab.jsx
import React from "react";
import SectionGrid from "../component/SectionGrid";

export default function AddressTab({
    activeSubTab,            // "supplier" | "buyer"
    setActiveSubTab,
    supplierFields,
    buyerFields,
    formData,
    errors,
    onChange,
    readOnly,
    getInputTypeForField,
    getValueForField,
}) {
    return (
        <div>
            <ul className="nav nav-pills mb-3 gap-1 bg-light p-1 rounded shadow-sm">
                <li className="nav-item">
                    <button
                        type="button"
                        className={`nav-link px-4 py-1 fw-semibold ${activeSubTab === "supplier" ? "active btn-primary text-white" : "text-dark"}`}
                        onClick={() => setActiveSubTab("supplier")}
                    >
                        <i className="bi bi-person-lines-fill me-2" /> Customer
                    </button>
                </li>
                <li className="nav-item">
                    <button
                        type="button"
                        className={`nav-link px-4 py-1 fw-semibold ${activeSubTab === "buyer" ? "active btn-primary text-white" : "text-dark"}`}
                        onClick={() => setActiveSubTab("buyer")}
                    >
                        <i className="bi bi-truck me-2" /> Ship To
                    </button>
                </li>
            </ul>

            <div className="rounded p-3">
                {activeSubTab === "supplier" ? (
                    <SectionGrid
                        fields={supplierFields}
                        formData={formData}
                        errors={errors}
                        onChange={onChange}
                        readOnly={readOnly}
                        idPrefix="address-supplier"
                        getInputTypeForField={getInputTypeForField}
                        getValueForField={getValueForField}
                    />
                ) : (
                    <SectionGrid
                        fields={buyerFields}
                        formData={formData}
                        errors={errors}
                        onChange={onChange}
                        readOnly={readOnly}
                        idPrefix="address-buyer"
                        getInputTypeForField={getInputTypeForField}
                        getValueForField={getValueForField}
                    />
                )}
            </div>
        </div>
    );
}
